export default __webpack_public_path__ + "static/media/php.d7c9415b.png";